import RegisterForm from "../components/RegisterForm";

function RegisterPage() {
    return (
        <RegisterForm />
    );
}

export default RegisterPage;